import { AHInput, Box } from "arkh";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { TextInput } from "react-native";

export const TitleInput = ({
  setTitle,
  title,

  onFocus,

  ref,
}: {
  title: string;
  setTitle(_: string): void;
  onFocus(): void;

  ref: React.RefObject<TextInput | null>;
}) => {
  const intl_tokens = useIntlTokens();

  return (
    <Box spaceHorizontal="small" style={{ flex: 1 }}>
      <AHInput
        ref={ref}
        value={title}
        spaceVertical="xsmall"
        onChangeText={setTitle}
        spaceHorizontal="small"
        autoCapitalize="sentences"
        placeholder={intl_tokens.Title}
        textType="list-item-title"
        style={{ flex: 1 }}
        onFocus={onFocus}
        //  autoFocus={autoFocus}
      />
    </Box>
  );
};
